import { SearchtokenType } from '@/api/get-search-tokens-by-type.ts'
import { AlertDialog, AlertDialogTrigger } from '@/components/ui/alert-dialog.tsx'
import { Button } from '@/components/ui/button.tsx'
import { Dialog, DialogTrigger } from '@/components/ui/dialog.tsx'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select.tsx'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table.tsx'
import { AddNewSearchTokenDialog } from '@/routes/_app/admin/-components/add-new-search-token-dialog.tsx'
import { DeleteSearchTokenDialog } from '@/routes/_app/admin/-components/delete-search-token-dialog.tsx'
import { useFetchSearchTokens } from '@/routes/_app/admin/-hooks/use-fetch-search-tokens.ts'
import { EmptyLoadingTable } from '@/routes/_app/syncs/-components/empty-loading-table.tsx'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { Plus, Trash } from 'lucide-react'
import { z } from 'zod'

export const Route = createFileRoute('/_app/admin/search-tokens')({
  component: SearchTokens,
  validateSearch: zodValidator(
    z.object({
      type: z.enum(['ANIME', 'MANGA']).default('ANIME'),
    }),
  ),
})

function SearchTokens() {
  const { type } = Route.useSearch()
  const navigate = Route.useNavigate()
  const { data: searchTokens = [], isLoading, error } = useFetchSearchTokens({ type })

  function setTokenType(type: SearchtokenType) {
    navigate({
      search: {
        type,
      },
    })
  }

  if (error) {
    return <div>Erro ao carregar tokens</div>
  }

  return (
    <section className="flex flex-col gap-4">
      <h1 className="text-center text-3xl font-bold tracking-tighter md:text-left">Tokens de busca</h1>

      <p className="text-center text-sm text-gray-500 md:text-left">
        Tokens de busca são usados para identificar novas atualizações de obras
      </p>

      <aside className="flex justify-between">
        <Select
          onValueChange={(value) => setTokenType(value as SearchtokenType)}
          value={type}
          defaultValue={type}
        >
          <SelectTrigger className="h-10 w-full max-w-[200px] ">
            <SelectValue placeholder="Selecione o tipo o token" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="ANIME">
              <span className="text-sm">Anime</span>
            </SelectItem>

            <SelectItem value="MANGA">
              <span className="text-sm">Manga</span>
            </SelectItem>
          </SelectContent>
        </Select>

        <Dialog>
          <DialogTrigger asChild>
            <Button variant="outline">
              <Plus className="mr-2 size-4" />
              Adicionar token
            </Button>
          </DialogTrigger>

          <AddNewSearchTokenDialog />
        </Dialog>
      </aside>

      <div className="rounded-sm border">
        <Table>
          <TableHeader>
            <TableHead>Id</TableHead>
            <TableHead>Token</TableHead>
            <TableHead>Tipo</TableHead>
            <TableHead>Criado em</TableHead>
            <TableHead></TableHead>
          </TableHeader>
          <TableBody>
            {isLoading && <EmptyLoadingTable />}

            {searchTokens.map((token) => (
              <TableRow key={token.id}>
                <TableCell>{token.id}</TableCell>
                <TableCell>{token.token}</TableCell>
                <TableCell>{token.type}</TableCell>
                <TableCell>{token.createdAt}</TableCell>
                <TableCell>
                  <AlertDialog>
                    <DeleteSearchTokenDialog searchToken={token} />
                    <AlertDialogTrigger asChild>
                      <Button variant="ghost" size="icon">
                        <Trash className="size-4" />
                      </Button>
                    </AlertDialogTrigger>
                  </AlertDialog>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </section>
  )
}
